import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getJwtToken, END_POINT } from "../../AdminReducer/action";

const resolveToken = () => {
  try {
    const token = getJwtToken();
    if (token) return token;
  } catch (e) {}
  try {
    const raw = sessionStorage.getItem("clinic-application-jwt") || localStorage.getItem("clinic-application-jwt");
    if (!raw) return "";
    const userData = JSON.parse(raw);
    return userData?.token ? "Bearer " + String(userData.token) : "";
  } catch (err) {
    return "";
  }
};

export const getAllMedicines = createAsyncThunk(
  "medicines/getAll",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${END_POINT}/inventory/inventoryMedicines`, {
        headers: {
          Authorization: resolveToken()
        }
      });
      return Array.isArray(res.data) ? res.data : (Array.isArray(res.data?.data) ? res.data.data : []);
    } catch (error) {
      if (error.response?.status === 404) {
        return [];
      }
      console.error("Failed to load inventory medicines:", error);
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const getMedicinePotency = createAsyncThunk(
  "medicines/getPotency",
  async (medicineName, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${END_POINT}/inventory/MedicinePotencies/${encodeURIComponent(medicineName)}`, {
        headers: {
          Authorization: resolveToken()
        }
      });
      return Array.isArray(res.data) ? res.data : [];
    } catch (error) {
      if (error.response?.status === 404) {
        return [];
      }
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
